import { render } from "./help.vue?vue&type=template&id=39e24df8&scoped=true&bindings={\"clearStorageResponsa\":\"options\"}"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"

import "./help.vue?vue&type=style&index=0&id=39e24df8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39e24df8"
/* custom blocks */
import block0 from "./help.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script